__turbopack_context__.v({
  "center": "_8mqvbW_center",
  "contentWrapper": "_8mqvbW_contentWrapper",
  "fullScreen": "_8mqvbW_fullScreen",
  "fullWidth": "_8mqvbW_fullWidth",
  "modal": "_8mqvbW_modal",
});
